import {useCallback, useContext} from 'react';

import {ValidationContext} from 'src/contexts/validation-context';

import {VALIDATION_ERRORS} from '../constants';

import type {ValidationContextType} from 'src/contexts/validation-context';

export const useValidateEZProxy = () => {
    const {addError, removeError} = useContext<ValidationContextType>(ValidationContext);

    const onValidateEZProxy = useCallback((proxy: string) => {

        if (proxy && !proxy.includes('.')) {
            addError({
                code: 'INVALID_PROXY_LINK',
                controlId: 'ez-proxy',
                message: VALIDATION_ERRORS.INVALID_PROXY_LINK,
            });
        } else {
            removeError('ez-proxy', ['INVALID_PROXY_LINK']);
        }
    }, [addError, removeError]);

    return {onValidateEZProxy};
};
